import { UIText3 } from '@cian/ui-kit';
import { IconProductDocumentsVerified16 } from '@cian/ui-kit-design-tokens/icons';
import styles from './Proof.css';

interface IProofProps {
  text: string;
}

export function Proof({ text }: IProofProps) {
  return (
    <div className={styles['proof']}>
      <div className={styles['icon']}>
        <IconProductDocumentsVerified16 color="icon-main-default" />
      </div>
      <UIText3 color="text-primary-default">{text}</UIText3>
    </div>
  );
}
